import axios from "axios";
import * as ls from "local-storage";
import { userAgent } from 'next/server'

export default axios.create({
  baseURL: process.env.NEXT_PUBLIC_BE_URL,
  headers: {
    Authorization: `Bearer ${ls.get("__user_at")}`
  }
});